import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';

@Component({
  selector: 'app-freeswitch-integration-toolbar',
  standalone: true,
  imports: [CommonModule, LocalizationPipe],
  templateUrl: './freeswitch-integration-toolbar.component.html',
})
export class FreeSwitchIntegrationToolbarComponent {
  @Output() add = new EventEmitter<void>();
}
